<template>
  <div class="index-accesso-stabilimenti">
    <div class="dashboard" :style="{ height: (contenitoreHeight + 35) + 'px' }" v-if="showDashboard">

      <div class="col-24 header-country">
        <div class="contenitore-select">
          <div class="header-stato">
            {{ $t('indexAccStab.stato') }}
          </div>
          <el-select v-model="country" placeholder="" @change="changeCountry">
            <el-option v-for="item in countries" :key="item" :label="$t('indexAccStab')[item].toUpperCase()"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="contenitore-select" v-if="(typeOfUser === 'fornitore' && fornitori.length > 1)">
          <div class="header-stato">
            {{ $t('indexAccStab.fornitore') }}
          </div>
          <el-select v-model="fornitore" placeholder="" @change="changeFornitore">
            <el-option v-for="item in fornitori" :key="item.codForn" :label="item.codForn" :value="item.codForn">
              {{ (item.codForn + ' - ' + item.desForn) }}
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="row row-custom testata">
        <div class="card-testata col-xl-6 col-md-12 col-24">
          <dashboard-card-doppia :properties="ordiniAperti"></dashboard-card-doppia>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24">
          <dashboard-card :properties="ultimoOrdine"></dashboard-card>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24">
          <dashboard-card :properties="dipendenti"></dashboard-card>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24">
          <dashboard-card :properties="documenti"></dashboard-card>
        </div>
      </div>

      <div class="row row-custom centrale">
        <div class="col-xl-12 col-24 grafico-torta">
          <div class="col-24 grafico no-padding">
            <donut-chart :title="($t('indexAccStab.titoloTorta').toUpperCase())" :options="optionsTorta"
              :chartData="rowsTorta" :chartColumns="columnsTorta" :isAdmin="isAdmin" />
          </div>
        </div>
        <div class="col-xl-12 col-24 documenti">
          <div class="col-24 elenco-doc no-padding">
            <div class="titolo">
              {{ $t('indexAccStab.documenti').toUpperCase() }}
            </div>
            <div class="col-24 no-padding">
              <el-table :data="doc_data" class="col-xs-24 custom-table table-doc no-padding" v-loading="doc_Loading">
                <el-table-column :label="$t('indexAccStab.sta')" width="160">
                  <template slot-scope="scope">
                    <div class="cell no-padding cell-stab">
                      {{ scope.row.first === 'Y' ? scope.row.stabilimento : '' }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="numOrd" :label="$t('indexAccStab.ordine')" min-width="100" />

                <el-table-column header-align="center" align="center" :label="$t('indexAccStab.validita')" width="100">
                  <template slot-scope="scope">
                    <div class="cell no-padding">
                      {{ scope.row.validita === '' ? '' : moment(scope.row.validita, 'DDMMYYYY').format('DD/MM/YYYY') }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="numDocDitta" :label="$t('indexAccStab.docDitta')" max-width="100"
                  header-align="center" align="center" />

                <el-table-column prop="numDocDip" :label="$t('indexAccStab.docDip')" max-width="100"
                  header-align="center" align="center" />
              </el-table>

              <el-pagination v-if="(doc_pag.nrPages > 1)" :current-page="doc_pag.currentPage" background
                class="custom-pagination paginatore" layout="prev, pager, next" :total="doc_pag.nrItems"
                :page-size="doc_pag.pag_for" @current-change="changePageDoc" />
            </div>
          </div>
        </div>
      </div>

      <div class="row row-custom centrale">
        <div :class="(country === 2 || country === 1 || country === 4) ? 'col-xl-8' : 'col-xl-12'"
          class="col-24 dipendenti">
          <div class="col-24 elenco-dip no-padding">
            <div class="titolo">
              {{ $t('indexAccStab.dipendenti').toUpperCase() }}
            </div>
            <div class="body">
              <div class="icon">
                <icon name="riv-people" scale="6" />
              </div>
              <el-carousel arrow="never" :autoplay="false" indicator-position="outside" trigger="click"
                @change="changeSchedaDip" v-if="(cards.length > 0)">
                <el-carousel-item v-for="dip_scheda in dip_nrSchede" :key="dip_scheda">
                  <div class="card-dip" v-for="item in dip_cards" :key="(item.codStab)">
                    <div class="stab">
                      {{ item.stabilimento }}
                    </div>
                    <div class="nr-dip">
                      {{ item.dipendenti }}
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-24 video" v-if="country === 2">
          <div class="col-24 video-div no-padding">
            <div class="titolo">
              {{ $t('indexAccStab.video').toUpperCase() }}
            </div>
            <div class="body">
              <div class="sub-text">
                {{ $t('indexAccStab.comeFunziona') }}
              </div>
              <div class="icon pointer" @click="openVideo(country)">
                <icon name="riv-player" scale="4.5" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-24 video" v-if="country === 4">
          <div class="col-24 video-div no-padding">
            <div class="titolo">
              {{ $t('indexAccStab.video').toUpperCase() }}
            </div>
            <div class="body">
              <div class="sub-text">
                {{ $t('indexAccStab.comeFunziona') }}
              </div>
              <div class="icon pointer" @click="openVideo(country)">
                <icon name="riv-player" scale="4.5" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-24 video" v-if="country === 1">
          <div class="col-24 video-div no-padding">
            <div class="titolo">
              {{ $t('indexAccStab.subappalto').toUpperCase() }}
            </div>
            <div class="body">
              <div class="sub-text">
                <span v-html="$t('indexAccStab.subappaltoText')" />
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="col-xl-12 col-24 carosello" v-loading="caroselloLoading">
          <el-carousel :arrow="ifArrow" :autoplay="false" indicator-position="none" @change="changeScheda" v-if="(cards.length > 0)">
            <el-carousel-item v-for="scheda in nrSchede" :key="scheda">
              <div class="card-stabilimento" v-for="item in cards" :key="(item.codSoc + item.codMag)">
                <div class="scheda">
                  <div class="scheda-stab">
                    {{ item.desMag }}
                  </div>
                  <div class="scheda-nr-ordini">
                    {{ item.nrOrdAperti }}
                  </div>
                  <div class="scheda-label">
                    {{ $t('indexAccStab.ordini') }}
                  </div>
                  <div class="scheda-valore">
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        -->
        <div class="col-xl-12 col-24 row row-custom documenti-generici">
          <div class="col-18 sx" v-loading="doc_box_loading">
            <div class="contenitore col-24 no-padding">
              <div class="titolo col-24">
                {{ $t('indexAccStab.titoloDocumenti').toUpperCase() }}
                <span class="download">
                  {{ '(' + $t('indexAccStab.download') + ')' }}
                </span>
              </div>
              <div class="col-24" style="height: 248px">
                <el-carousel trigger="click" class="carosello-docs" :class="(doc_box_nrPages > 1) ? 'multi' : 'single'"
                  arrow="never" :autoplay="false" @change="cambioScheda"
                  :indicator-position="((doc_box_nrPages > 1) ? 'outside' : 'none')">
                  <el-carousel-item v-for="item in doc_box_nrPages" :key="item" class="carosello-item row row-custom ">

                    <div class="box-container-sx col-12">
                      <!-- Scheda 1 (index: 0) -->
                      <a :href="'static/docs/AccessoStabilimenti/' + doc_box_schede[0].link" target="_blank"
                        v-if="doc_box_schede[0]">
                        <div class="box pointer"
                          :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]">
                          <div class="nome-doc col-24" v-html="doc_box_schede[0].titolo" />
                          <div class="data col-24" :style="[(doc_box_nrPages > 1) ? { 'marginTop': '0px' } : {}]">
                            {{ doc_box_schede[0].data.toUpperCase() }}
                          </div>
                          <icon name="riv-word2" scale="2" class="icona" />
                        </div>
                      </a>
                      <div class="box" :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]"
                        v-else>
                      </div>

                      <!-- Scheda 3 (index: 2) -->
                      <a :href="'static/docs/AccessoStabilimenti/' + doc_box_schede[2].link" target="_blank"
                        v-if="doc_box_schede[2]">
                        <div class="box pointer"
                          :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]">
                          <div class="nome-doc col-24" v-html="doc_box_schede[2].titolo" />
                          <div class="data col-24" :style="[(doc_box_nrPages > 1) ? { 'marginTop': '0px' } : {}]">
                            {{ doc_box_schede[2].data.toUpperCase() }}
                          </div>
                          <icon name="riv-word2" scale="2" class="icona" />
                        </div>
                      </a>
                      <div class="box" :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]"
                        v-else>
                      </div>
                    </div>
                    <div class="box-container-dx col-12">
                      <!-- Scheda 2 (index: 1) -->
                      <a :href="'static/docs/AccessoStabilimenti/' + doc_box_schede[1].link" target="_blank"
                        v-if="doc_box_schede[1]">
                        <div class="box pointer"
                          :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]">
                          <div class="nome-doc col-24" v-html="doc_box_schede[1].titolo" />
                          <div class="data col-24" :style="[(doc_box_nrPages > 1) ? { 'marginTop': '0px' } : {}]">
                            {{ doc_box_schede[1].data.toUpperCase() }}
                          </div>
                          <icon name="riv-word2" scale="2" class="icona" />
                        </div>
                      </a>
                      <div class="box" :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]"
                        v-else>
                      </div>

                      <!-- Scheda 4 (index: 3) -->
                      <a :href="'static/docs/AccessoStabilimenti/' + doc_box_schede[3].link" target="_blank"
                        v-if="doc_box_schede[3]">
                        <div class="box pointer"
                          :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]">
                          <div class="nome-doc col-24" v-html="doc_box_schede[3].titolo" />
                          <div class="data col-24" :style="[(doc_box_nrPages > 1) ? { 'marginTop': '0px' } : {}]">
                            {{ doc_box_schede[3].data.toUpperCase() }}
                          </div>
                          <icon name="riv-word2" scale="2" class="icona" />
                        </div>
                      </a>
                      <div class="box" :style="[(doc_box_nrPages > 1) ? { 'height': '105px' } : { 'height': '110px' }]"
                        v-else>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="col-6 dx" v-loading="doc_box_loading">
            <a :href="'static/docs/AccessoStabilimenti/' + doc_box_manuale.link" target="_blank"
              v-if="doc_box_manuale.link">
              <div class="contenitore pointer col-24 no-padding">
                <div class="titolo">
                  <icon name="riv-manuale" scale="3.5" class="icona" />
                  <div class="text">
                    {{ doc_box_manuale.titolo.toUpperCase() }}
                  </div>
                </div>
                <div class="nome-doc">
                  {{ doc_box_manuale.sottoTitolo.toUpperCase() }}
                </div>
                <icon name="riv-pdfMan" scale="2.5" class="icona-pdf" />
                <div class="data">
                  {{ doc_box_manuale.data.toUpperCase() }}
                </div>
              </div>
            </a>
            <!-- Box vuoto in assenza di manuale operativo -->
            <div class="contenitore col-24 no-padding" v-else />
          </div>
        </div>
      </div>
    </div>

    <keep-alive>
      <router-view :contenitoreHeight="contenitoreHeight"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import DashboardCard from '@/components/ServiceComponents/DashboardCard'
import DashboardCardDoppia from '@/components/ServiceComponents/DashboardCardDoppia'
import { bus } from '../Bus.js'
import DonutChart from '../ServiceComponents/DonutChart.vue'
import moment from 'moment'

export default {
  name: 'IndexAccessoStabilimenti',
  components: {
    DonutChart,
    DashboardCard, DashboardCardDoppia
  },
  i18n: {
    messages: {
      it_IT: {
        indexAccStab: {
          1: 'Italia',
          2: 'Francia',
          3: 'Spagna',
          4: 'Belgio',
          5: 'Germania',
          nOrdiniAperti: 'Ordini Aperti',
          nOrdiniConScaduto: 'Ordini con Scaduto',
          titoloTorta: 'Ordini aperti per stabilimento',
          ordini: 'ordini',
          ultimoOrdine: 'Ultimo Ordine',
          stato: 'Stato: ',
          dipendenti: 'Dipendenti Assegnati',
          documenti: 'Documenti Non in Regola',
          ordine: 'Ordine',
          sta: 'Stabilimento',
          docDitta: 'Ditta',
          docDip: 'Dipendente',
          validita: 'Validità',
          titoloDocumenti: 'Documenti',
          download: 'Download',
          fornitore: 'Fornitore: ',
          video: 'Video',
          comeFunziona: 'Come funziona il Portale Fornitori?',
          subappalto: 'Subappalto',
          subappaltoText: 'Per l\'autorizzazione del subappalto, contattare il proprio referente dell\'ufficio acquisti della Sede di Milano.<br /><br />Numero centralino: +39.02.30700'
        }
      },
      fr_FR: {
        indexAccStab: {
          1: 'Italie',
          2: 'France',
          3: 'Espagne',
          4: 'Belgique',
          5: 'Allemagne',
          nOrdiniAperti: 'N° Commandes Ouvertes',
          nOrdiniConScaduto: 'avec Expiré',
          titoloTorta: 'Commandes ouvertes d\'usine',
          ordini: 'commandes',
          ultimoOrdine: 'Dernière Commande',
          stato: 'Nation: ',
          dipendenti: 'Employés affectés',
          documenti: 'Documents non en ordre',
          ordine: 'Commande',
          sta: 'Établissement',
          docDitta: 'Entreprise',
          docDip: 'Employé',
          validita: 'Validité',
          titoloDocumenti: 'Documents',
          download: 'Download',
          fornitore: 'Fournisseur: ',
          video: 'Vidéo',
          comeFunziona: 'Comment fonctionne le Portail Fournisseur?',
          subappalto: 'Subappalto',
          subappaltoText: 'Per l\'autorizzazione del subappalto, contattare il proprio referente dell\'ufficio acquisti della Sede di Milano.<br /><br />Numero centralino: +39.02.30700'
        }
      },
      es_ES: {
        indexAccStab: {
          1: 'Italia',
          2: 'Francia',
          3: 'España',
          4: 'Bélgica',
          5: 'Alemania',
          nOrdiniAperti: 'Pedidos Abiertos',
          nOrdiniConScaduto: 'Pendientes',
          titoloTorta: 'Pedidos abiertos por sociedad',
          ordini: 'pedidos',
          ultimoOrdine: 'Último Pedido',
          stato: 'Estado: ',
          dipendenti: 'Empleados asignados',
          documenti: 'Documentos que no están en orden',
          ordine: 'Orden',
          sta: 'Establecimiento',
          docDitta: 'Firma',
          docDip: 'Empleado',
          validita: 'Validez',
          titoloDocumenti: 'Documentos',
          download: 'Download',
          fornitore: 'Proveedor: ',
          video: 'Video',
          comeFunziona: '¿Cómo funciona el Portal de Proveedores?',
          subappalto: 'Subappalto',
          subappaltoText: 'Per l\'autorizzazione del subappalto, contattare il proprio referente dell\'ufficio acquisti della Sede di Milano.<br /><br />Numero centralino: +39.02.30700'
        }
      },
      de_DE: {
        indexAccStab: {
          1: 'Italien',
          2: 'Frankreich',
          3: 'Spanien',
          4: 'Belgien',
          5: 'Deutschland',
          nOrdiniAperti: 'Offene Bestellungen',
          nOrdiniConScaduto: 'davon fällig',
          titoloTorta: 'Offene Aufträge nach Werken',
          ordini: 'aufträge',
          ultimoOrdine: 'Letzte Bestellung',
          stato: 'Land: ',
          dipendenti: 'Zugewiesene Mitarbeiter',
          documenti: 'Dokumente nicht in Ordnung',
          ordine: 'Auftrag',
          sta: 'Einrichtung',
          docDitta: 'Feste',
          docDip: 'Mitarbeiter',
          validita: 'Gültigkeit',
          titoloDocumenti: 'Dokumente',
          download: 'Download',
          fornitore: 'Lieferant: ',
          video: 'Video',
          comeFunziona: 'Wie funktioniert das Lieferantenportal?',
          subappalto: 'Subappalto',
          subappaltoText: 'Per l\'autorizzazione del subappalto, contattare il proprio referente dell\'ufficio acquisti della Sede di Milano.<br /><br />Numero centralino: +39.02.30700'
        }
      },
      en_GB: {
        indexAccStab: {
          1: 'Italy',
          2: 'France',
          3: 'Spain',
          4: 'Belgium',
          5: 'Germany',
          nOrdiniAperti: 'Nr. Open Orders',
          nOrdiniConScaduto: 'with Expired',
          titoloTorta: 'Factory open orders',
          ordini: 'orders',
          ultimoOrdine: 'Last Order',
          stato: 'Country: ',
          dipendenti: 'Assigned Employees',
          documenti: 'Documents not in order',
          ordine: 'Order',
          sta: 'Establishment',
          docDitta: 'Firm',
          docDip: 'Employee',
          validita: 'Validity',
          titoloDocumenti: 'Documents',
          download: 'Download',
          fornitore: 'Supplier: ',
          video: 'Video',
          comeFunziona: 'How does the Supplier Portal work?',
          subappalto: 'Subappalto',
          subappaltoText: 'Per l\'autorizzazione del subappalto, contattare il proprio referente dell\'ufficio acquisti della Sede di Milano.<br /><br />Numero centralino: +39.02.30700'
        }
      }
    }
  },
  props: {
    contenitoreHeight: {
      type: Number,
      required: true,
      default: 550
    }
  },
  data() {
    return {
      moment: moment,
      isAdmin: false,
      caroselloLoading: true,
      nrSchede: 0,
      cards: [],
      columnsTorta: [{
        'type': 'string',
        'label': 'Stabilimento'
      }, {
        'type': 'number',
        'label': 'Ordini Aperti'
      }],
      rowsTorta: [],
      optionsTorta: {
        height: 255,
        pieHole: 0.5,
        backgroundColor: '#fff',
        chartArea: {
          width: '100%',
          top: 35,
          height: 200,
          left: 0
        },
        colors: ['#48adb5', '#bd3090', '#7d3d87', '#111858', '#2b6165', '#ccc', '#b5e2e6', '#c1a9b9', '#aca3ad', '#665f75', '#b97ccd'],
        fontName: 'os-regular',
        legend: {
          position: 'right',
          textStyle: {
            color: '#007c74',
            fontName: 'os-regular',
            fontSize: 13
          }
        },
        pieSliceTextStyle: {
          fontSize: 10
        },
        tooltip: {
          trigger: 'selection'
        }
      },
      countries: [],
      country: '',
      codLang: sessionStorage.getItem('codLang'),
      ordiniAperti: {
        bgColorUp: 'linear-gradient(to right, #00635c, #02b1a6)',
        bgColorDown: '#48adb5',
        iconColorUp: '#fff',
        iconColorDown: '#fff',
        titleUp: '',
        titleDown: '',
        iconaUp: 'riv-ordiniAperti',
        iconaDown: 'riv-hourglass',
        type: 'Numero',
        valueUp: '0',
        valueDown: '0'
      },
      ultimoOrdine: {
        bgColor: 'linear-gradient(to right, #3e1844, #af55a8)',
        iconColor: '#fff',
        title: '',
        icona: 'riv-calendar2',
        type: 'Data',
        id: '',
        data: ''
      },
      dipendenti: {
        bgColor: 'linear-gradient(to right, #AC237F, #bb629f)',
        iconColor: '#fff',
        title: '',
        icona: 'riv-people',
        type: 'Numero',
        value: '0',
      },
      documenti: {
        bgColor: 'linear-gradient(to right, #111858, #242f96)',
        iconColor: '#fff',
        title: '',
        icona: 'riv-docs',
        type: 'Numero',
        value: '0',
      },
      ordiniData: [],
      codForn: '',
      // Dipendenti
      dip_data: [],
      dip_cards: [],
      dip_nrSchede: 0,
      // Documenti
      doc_Loading: true,
      doc_data: [],
      doc_pag: {
        currentPage: 1,
        pag_for: 6,
        nrPages: 0,
        nrItems: 0,
        counterWarning: 0
      },
      // BOX Documenti
      doc_box_loading: true,
      doc_box_docs: [],
      doc_box_nrPages: 1,
      doc_box_index: 0,
      doc_box_schede: [],
      doc_box_manuale: {},
      // Fornitore
      typeOfUser: '',
      fornitore: '',
      fornitori: []
    }
  },
  computed: {
    showDashboard: function () {
      let path = this.$route.path
      return (path === '/accessostabilimenti' || path === '/accessostabilimenti/')
    },
    ifArrow: function () {
      if (this.nrSchede > 1) {
        return 'always'
      } else {
        return 'never'
      }
    }
  },
  activated: function () {
    this.init()
    // bus.$emit('Header_ChangeAdmin', this.country, 'ACCSTA')
  },
  mounted: function () {
    bus.$on('Header_SetCodFornAdmin', () => {
      this.resetDati()

      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['ACCSTA'][this.country])
      } else {
        this.$set(this, 'codForn', '')
      }

      // this.callServices()
      this.getFornitoreInfo()
    })
    bus.$on('ACCSTA_ChangeCountryFromApp', () => {
      this.changeCountry(localStorage.getItem('ACCSTA_country'), true)
    })
    bus.$on('changeLanguage', () => {
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      this.$nextTick(() => {
        this.ordiniAperti.titleUp = this.$t('indexAccStab.nOrdiniAperti')
        this.ordiniAperti.titleDown = this.$t('indexAccStab.nOrdiniConScaduto')
        this.ultimoOrdine.title = this.$t('indexAccStab.ultimoOrdine')
        this.dipendenti.title = this.$t('indexAccStab.dipendenti')
        this.documenti.title = this.$t('indexAccStab.documenti')
      })
    })
  },
  methods: {
    resetDati: function () {
      this.$set(this, 'caroselloLoading', true)
      this.$set(this, 'isAdmin', false)

      this.$set(this, 'cards', [])
      this.$set(this, 'ordiniData', [])
      this.$set(this, 'rowsTorta', [])
      this.$set(this.ordiniAperti, 'valueUp', '0')
      this.$set(this.ordiniAperti, 'valueDown', '0')
      this.$set(this.ultimoOrdine, 'id', '')
      this.$set(this.ultimoOrdine, 'data', '')

      // Dipendenti
      this.$set(this.dipendenti, 'value', '0')
      this.$set(this, 'dip_data', [])
      this.$set(this, 'dip_cards', [])
      this.$set(this, 'dip_nrSchede', '0')

      // Documenti
      this.$set(this.documenti, 'value', '0')
      this.$set(this, 'doc_data', [])
      this.$set(this, 'doc_pag', {
        currentPage: 1,
        pag_for: 6,
        nrPages: 0,
        nrItems: 0,
        counterWarning: 0
      })

      // BOX Documenti
      this.$set(this, 'doc_box_loading', true)
      this.$set(this, 'doc_box_docs', [])
      this.$set(this, 'doc_box_nrPages', 1)
      this.$set(this, 'doc_box_index', 0)
      this.$set(this, 'doc_box_schede', [])
      this.$set(this, 'doc_box_manuale', {})
    },
    init: function () {
      this.resetDati()
      this.getCountries()
      this.$nextTick(() => {
        this.ordiniAperti.titleUp = this.$t('indexAccStab.nOrdiniAperti')
        this.ordiniAperti.titleDown = this.$t('indexAccStab.nOrdiniConScaduto')
        this.ultimoOrdine.title = this.$t('indexAccStab.ultimoOrdine')
        this.dipendenti.title = this.$t('indexAccStab.dipendenti')
        this.documenti.title = this.$t('indexAccStab.documenti')
      })
    },
    getOrdiniDsh: function () {
      this.$http.get('dashboardaccstab/ordini', {
        params: {
          codForn: this.codForn,
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          try {
            if (response.body.rc === 0) {
              this.$set(this.ordiniAperti, 'valueUp', response.body.attrib.nrOrdAperti)
              this.$set(this.ordiniAperti, 'valueDown', response.body.attrib.nrOrdParzScaduti)
              this.$set(this.ultimoOrdine, 'id', response.body.attrib.nrUltOrdine)
              this.$set(this.ultimoOrdine, 'data', response.body.attrib.dataUltOrdine)
              this.$set(this, 'ordiniData', response.body.data)

              this.nrSchede = (this.ordiniData.length % 4 > 0) ? (parseInt(this.ordiniData.length / 4) + 1) : (parseInt(this.ordiniData.length / 4))
              let i = 0
              while (i < 4) {
                if (this.ordiniData[i] !== undefined) {
                  this.cards.push(this.ordiniData[i])
                }
                i++
              }

              let arrayTemp = []
              for (let i = 0; i < this.ordiniData.length; i++) {
                let obj = this.ordiniData[i]
                let array = [obj.desMag + ' - ' + obj.desSoc, parseInt(obj.nrOrdAperti)]
                arrayTemp.push(array)
              }
              this.$set(this, 'rowsTorta', arrayTemp)
            } else {
              if (['1001', '0101'].indexOf(response.body.msg[0].msgId) < 0) {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              } else {
                this.isAdmin = true
              }
              this.$set(this, 'rowsTorta', [])
              this.$set(this.ultimoOrdine, 'id', '')
              this.$set(this.ultimoOrdine, 'data', '')
              this.$set(this, 'cards', [])
            }
            this.$set(this, 'caroselloLoading', false)
          }
          catch (err) {
            console.log(err)
          }
        })
    },
    getDipendentiDsh: function () {
      this.$http.get('dashboardaccstab/dipendenti', {
        params: {
          codForn: this.codForn,
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          try {
            if (response.body.rc === 0) {

              this.$set(this.dipendenti, 'value', response.body.attrib.numDip)
              this.$set(this, 'dip_data', response.body.data)

              this.dip_nrSchede = (this.dip_data.length % 4 > 0) ? (parseInt(this.dip_data.length / 4) + 1) : (parseInt(this.dip_data.length / 4))
              let i = 0
              while (i < 5) {
                if (this.dip_data[i] !== undefined) {
                  this.dip_cards.push(this.dip_data[i])
                }
                i++
              }
            } else {

            }
            this.$set(this, 'caroselloLoading', false)
          }
          catch (err) {
            console.log(err)
          }
        })
    },
    getDocumentiDsh: function () {
      this.$set(this, 'doc_Loading', true)
      this.$http.get('dashboardaccstab/documenti', {
        params: {
          codForn: this.codForn,
          codLang: this.codLang,
          country: this.country,
          pag_action: (this.doc_pag.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: (this.doc_pag.currentPage - 1) * this.doc_pag.pag_for + 1,
          pag_for: this.doc_pag.pag_for
        }
      })
        .then(response => {
          try {
            if (response.body.rc === 0) {
              this.$set(this, 'doc_data', response.body.data)
              if (this.doc_pag.currentPage === 1) {
                this.$set(this.documenti, 'value', response.body.attrib.numDoc)
                this.$set(this.doc_pag, 'nrItems', parseInt(response.body.attrib.size))
                let resto = parseInt(response.body.attrib.size) % this.doc_pag.pag_for
                let aggiunta = resto > 0 ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.doc_pag.pag_for) + aggiunta
                this.$set(this.doc_pag, 'nrPages', nrPages)
              }
            } else {
              this.$set(this, 'doc_data', [])
              this.$set(this.documenti, 'value', '0')
              this.$set(this, 'doc_pag', {
                currentPage: 1,
                pag_for: 6,
                nrPages: 0,
                nrItems: 0,
                counterWarning: 0
              })
            }
            this.$set(this, 'doc_Loading', false)
          }
          catch (err) {
            console.log(err)
          }
        })
    },
    getBoxDocumenti: function () {
      this.$set(this, 'doc_box_loading', true)
      let obj = {
        params: {
          codLang: this.language,
          country: this.country
        }
      }
      this.$http.get('dashboardaccstab/documentibox', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'doc_box_docs', response.body.data.docs)
            let nrPages = (this.doc_box_docs.length % 4 > 0) ? (parseInt(this.doc_box_docs.length / 4) + 1) : (parseInt(this.doc_box_docs.length / 4))
            this.$set(this, 'doc_box_nrPages', nrPages)
            let schede = []
            let i = 0
            while (i < 4) {
              if (this.doc_box_docs[i]) {
                schede.push(this.doc_box_docs[i])
              }
              i++
            }
            this.$set(this, 'doc_box_schede', schede)
            this.$set(this, 'doc_box_manuale', response.body.data.manuale)
          } else {

          }
          this.$set(this, 'doc_box_loading', false)
        })
        .catch((err) => { console.log(err) })
    },
    cambioScheda: function (newIndex, oldIndex) {
      this.$set(this, 'doc_box_schede', [])
      let schede = []
      for (let i = (newIndex * 4); i <= (newIndex * 4 + 3); i++) {
        let obj = this.doc_box_docs[i]
        if (obj) {
          schede.push(this.doc_box_docs[i])
        }
      }
      this.$set(this, 'doc_box_schede', schede)
    },
    changePageDoc: function (page) {
      this.$set(this.doc_pag, 'currentPage', page)
      this.getDocumentiDsh()
    },
    changeCountry: function (country, ifChangeCountryFromApp) {
      this.$set(this, 'country', parseInt(country))
      localStorage.setItem('ACCSTA_country', country)

      // Se sto cambiando Stato dalla dashboard cancello gli oggetti ricerca su VUEX e il fornitore ACCSTA salvato nel sessionStorage
      if (!ifChangeCountryFromApp) {
        this.$store.commit('set', { key: 'DIP_Ricerca', value: {} })
        this.$store.commit('set', { key: 'DIP_Dipendente', value: {} })
        this.$store.commit('set', { key: 'DIP_new', value: false })
        this.$store.commit('set', { key: 'DIP_Documento', value: {} })
        this.$store.commit('set', { key: 'DOC_Ricerca', value: {} })
        this.$store.commit('set', { key: 'GA_Documento', value: {} })
        this.$store.commit('set', { key: 'ASD_Ricerca', value: {} })
        this.$store.commit('set', { key: 'CON_Ricerca', value: {} })
        sessionStorage.removeItem('ACCSTA_fornitore')
      }

      // Emetto evento cambio Stato dalla dashboard ACCSTA
      bus.$emit('ACCSTA_ChangeCountryFromDsh')

      // Se esiste l'oggetto amministrazione nel localStorage recupero il codForn UFFACQ del nuovo Stato
      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['ACCSTA'][this.country])
      } else {
        this.$set(this, 'codForn', '')
      }

      // Emetto evento per informare HeaderApp del cambio Stato
      bus.$emit('Header_ChangeAdmin', this.country, 'ACCSTA')

      this.resetDati()

      this.getFornitoreInfo()
    },
    getCountries: function () {
      this.$http.get('portale/menu', {
        params: {
          codLang: this.codLang
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let data = response.body.data
            for (let i = 0; i < data.length; i++) {
              let obj = data[i]
              if (obj.area === 'ACCSTA') {
                let array = []
                for (let j = 0; j < obj.apps.length; j++) {
                  let app = obj.apps[j]
                  let appCountries = JSON.parse(app.countries)
                  for (let k = 0; k < appCountries.length; k++) {
                    let country = appCountries[k]
                    if (array.indexOf(country) < 0) {
                      array.push(country)
                    }
                  }
                }

                // Popolo gli stati a cui sono abilitato e seleziono lo stato salvato nel localStorage (se è tra quelli a cui sono abilitato)
                this.$set(this, 'countries', array)
                if (localStorage.hasOwnProperty('ACCSTA_country') && this.countries.indexOf(parseInt(localStorage.getItem('ACCSTA_country'))) >= 0) {
                  this.$set(this, 'country', parseInt(localStorage.getItem('ACCSTA_country')))
                } else {
                  this.$set(this, 'country', array[0])
                  localStorage.setItem('ACCSTA_country', array[0])
                }

                // Emetto l'evento per indicare a HeaderApp in quale area e in quale Stato sto lavorando
                bus.$emit('Header_ChangeAdmin', this.country, 'ACCSTA')

                // Richiamo il servizio per ottenere le info sull'utente
                this.getFornitoreInfo()
                // this.callServices()
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getFornitoreInfo: function () {
      this.$http.get('dashboardaccstab/info', {
        params: {
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let attrib = response.body.attrib
            let data = response.body.data
            this.$set(this, 'typeOfUser', attrib.typeOfUser)

            // L'utente è un fornitore oppure agente
            if (this.typeOfUser === 'fornitore') {
              // Popolo l'elenco dei codForn (per l'agente saranno più di uno)
              this.$set(this, 'fornitori', data)
              // Se esiste salvato sul sessionStorage un fornitore per ACCSTA lo uso
              if (sessionStorage.hasOwnProperty('ACCSTA_fornitore')) {
                this.$set(this, 'fornitore', sessionStorage.getItem('ACCSTA_fornitore'))
                this.$set(this, 'codForn', sessionStorage.getItem('ACCSTA_fornitore'))
              }
              // Altrimenti uso il primo restituito dal servizio
              else {
                this.$set(this, 'fornitore', data[0].codForn)
                this.$set(this, 'codForn', data[0].codForn)
                sessionStorage.setItem('ACCSTA_fornitore', this.codForn)
              }
            }
            // L'utente è amministratore (di tutte le applicazioni ACCSTA)
            else if (this.typeOfUser === 'admin') {
              // Imposto il codForn in base a ciò che è salvato nell'oggetto amministrazione
              if (localStorage.hasOwnProperty('amministrazione')) {
                this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['ACCSTA'][this.country])
              } else {
                this.$set(this, 'codForn', '')
              }
            }

            // Chiamo il metodo per chiamare i vari servizi di popolamento dashboard
            this.callServices()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changeFornitore: function () {
      this.$set(this, 'codForn', this.fornitore)
      this.$set(this, 'caroselloLoading', true)
      sessionStorage.setItem('ACCSTA_fornitore', this.codForn)
      this.$store.commit('set', { key: 'DIP_Ricerca', value: {} })
      this.$store.commit('set', { key: 'DIP_Dipendente', value: {} })
      this.$store.commit('set', { key: 'DIP_new', value: false })
      this.$store.commit('set', { key: 'DIP_Documento', value: {} })
      this.$store.commit('set', { key: 'DOC_Ricerca', value: {} })
      this.$store.commit('set', { key: 'GA_Documento', value: {} })
      this.$store.commit('set', { key: 'ASD_Ricerca', value: {} })
      this.$store.commit('set', { key: 'CON_Ricerca', value: {} })
      // Sul cambio del codForn resetto tutti i dati e richiamo tutti i servizi di popolamento dashboard
      this.resetDati()
      this.callServices()
    },
    callServices: function () {
      this.getOrdiniDsh()
      this.getDipendentiDsh()
      this.getDocumentiDsh()
      this.getBoxDocumenti()
    },
    changeScheda: function (newIndex, oldIndex) {
      this.$set(this, 'cards', [])
      for (let i = (newIndex * 4); i <= (newIndex * 4 + 3); i++) {
        let obj = this.ordiniData[i]
        if (obj !== null && obj !== undefined) {
          this.cards.push(this.ordiniData[i])
        }
      }
    },
    changeSchedaDip: function (newIndex, oldIndex) {
      this.$set(this, 'dip_cards', [])
      for (let i = (newIndex * 5); i <= (newIndex * 5 + 4); i++) {
        let obj = this.dip_data[i]
        if (obj !== null && obj !== undefined) {
          this.dip_cards.push(this.dip_data[i])
        }
      }
    },
    openVideo: function (country) {
      if (country === 2) {
        let url = 'https://www.rivaacier.com/download/video/portail_fournisseur_v2.mp4'
        window.open(url, '_blank')
      } else if (country === 4) {
        let url = 'https://www.rivagroup.com/download/belgio/animation_portail_fournisseu_belgium.mp4'
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-accesso-stabilimenti {
  .dashboard {
    -webkit-box-shadow: 0 0 10px 2px #cecece;
    -moz-box-shadow: 0 0 10px 2px #cecece;
    box-shadow: 0 0 10px 2px #cecece;
    background-color: #ffffff;
    margin: auto;
    overflow-x: hidden;
    margin-top: 25px;

    .header-country {
      height: 45px;
      text-align: right;
      margin-top: 5px;

      .contenitore-select {
        display: inline-block;
        margin-left: 20px;

        .header-stato {
          .set-font(@size: 17px, @family: 'os-regular');
          text-align: right;
          line-height: 30px;
          display: inline-block;
          margin-right: 10px;
        }

        .el-select {
          width: 230px;
          display: inline-block;

          .el-input {
            .el-input__inner {
              border-radius: 0;
              border: 0;
              border-bottom: 1px solid #666;
              height: 35px;
              .set-font(@size: 18px, @family: 'os-semibold', @color: #bd3090);
              letter-spacing: 4px;
            }

            .el-select__caret {
              color: #666;
              font-size: 22px;
            }
          }
        }
      }
    }

    .testata {
      .card-testata {
        margin-bottom: 10px;
      }
    }

    .centrale {
      margin-top: 5px;

      .grafico-torta {
        height: 100%;
        margin-bottom: 15px;

        .grafico {
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          box-shadow: 0px 0px 13px 1px #e7e7e7;

          .titolo-grafico {
            .set-font(@size: 13px; @weight: bold; @color: @greenRiva);
            letter-spacing: 3px;
            margin-top: 15px;
          }
        }
      }

      .carosello {
        height: 315px;
        margin-bottom: 15px;

        .el-carousel {
          height: 100%;

          .el-carousel__container {
            height: 100%;
            width: 100%;

            button:focus {
              outline: 0px auto;
            }

            .el-carousel__arrow {
              background-color: #fff;
              color: #ccc;
              font-size: 30px;
            }

            .el-carousel__item {
              padding-left: 10%;
              width: 90%;

              .card-stabilimento {
                height: 50%;
                width: 50%;
                display: inline-block;

                .scheda {
                  border: 1px solid #e7e7e7;
                  border-radius: 4px;
                  -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
                  -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
                  box-shadow: 0px 0px 13px 1px #e7e7e7;
                  width: 70%;
                  margin: 2% auto 2% auto;
                  height: 92%;
                  text-align: center;

                  .scheda-stab {
                    margin-top: 8px;
                    .set-font(@size: 18px; @color: #48adb5);
                  }

                  .scheda-nr-ordini {
                    margin-top: 10px;
                    .set-font(@size: 40px; @color: #bd3090);
                    line-height: 36px;
                  }

                  .scheda-label {
                    .set-font(@size: 16px; @color: #bd3090);
                  }

                  .scheda-valore {
                    margin-top: 5px;
                    .set-font(@size: 20px; @color: #3f2a6d);
                  }
                }
              }
            }
          }
        }
      }

      .video {
        height: 295px;
        margin-bottom: 15px;

        .video-div {
          height: 295px;
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          box-shadow: 0px 0px 13px 1px #e7e7e7;

          .titolo {
            padding: 0 15px;
            line-height: 35px;
            height: 45px;
            .set-font(@size: 14px; @family: 'os-semibold'; @color: @greenRiva);
            letter-spacing: 2px;
            text-align: center;
          }

          .body {
            .icon {
              text-align: center;
              margin-top: 40px;
              color: #cccccc;
            }

            .sub-text {
              padding: 0 15px;
              .set-font(@size: 13px; @family: 'os-semibold'; @color: #666);
              margin-top: 35px;
              text-align: center;
            }
          }
        }
      }

      .dipendenti {
        height: 295px;
        margin-bottom: 15px;

        .elenco-dip {
          height: 295px;
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          box-shadow: 0px 0px 13px 1px #e7e7e7;

          .titolo {
            padding-left: 15px;
            line-height: 35px;
            height: 45px;
            .set-font(@size: 14px; @family: 'os-semibold'; @color: @greenRiva);
            letter-spacing: 2px;

          }

          .body {
            .icon {
              float: left;
              width: 30%;
              height: 240px;
              text-align: center;
              padding-top: 60px;
              color: #cccccc;
            }

            .el-carousel {
              width: 70%;

              .el-carousel__container {
                height: 220px;

                .card-dip {
                  line-height: 40px;

                  .stab {
                    float: left;
                    width: 80%;
                    .set-font(@size: 18px; @family: 'os-semibold'; @color: #bd3090);
                  }

                  .nr-dip {
                    float: left;
                    width: 20%;
                    .set-font(@size: 28px; @family: 'os-regular'; @color: #48adb5);
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }

      .documenti {
        height: 290px;
        margin-bottom: 15px;

        .elenco-doc {
          height: 290px;

          /*border: 1px solid #e7e7e7;
            border-radius: 4px;
            -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
            -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
            box-shadow: 0px 0px 13px 1px #e7e7e7;*/
          .titolo {
            //padding-left: 15px;
            line-height: 25px;
            height: 30px;
            .set-font(@size: 14px; @family: 'os-semibold'; @color: @greenRiva);
            letter-spacing: 2px;

          }

          .el-table__body-wrapper {
            height: 205px;

            .cell-stab {
              .set-font(@size: 12px; @family: 'os-semibold'; @color: @textTable);
            }
          }

          .paginatore {
            margin: 7px 0;
          }
        }
      }

      .documenti-generici {
        height: 295px;
        margin-bottom: 15px;

        .contenitore {
          height: 100%;
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          box-shadow: 0px 0px 13px 1px #e7e7e7;
        }

        .sx {
          padding-left: 0;
          padding-right: 15px;

          .titolo {
            padding-left: 15px;
            line-height: 35px;
            height: 45px;
            .set-font(@size: 14px, @family: 'os-semibold', @color: @greenRiva);
            letter-spacing: 2px;

            .download {
              .set-font(@size: 14px, @family: 'os-lightitalic', @color: @greenRiva);
              letter-spacing: 1px;
            }
          }

          .carosello-docs {
            width: 100%;
            height: 100%;
          }

          .single {
            .el-carousel__container {
              height: 235px;
            }
          }

          .multi {
            .el-carousel__container {
              height: 220px;
            }
          }

          .box-container-sx {
            padding-left: 0;
            padding-right: 5px;
          }

          .box-container-dx {
            padding-left: 5px;
            padding-right: 0;
          }

          a:hover {
            text-decoration: none;
          }

          .box {
            border: 1px solid #e7e7e7;
            border-radius: 4px;
            height: 110px;
            margin-bottom: 10px;
            position: relative;

            .nome-doc {
              .set-font(@size: 14px, @family: 'os-semibold', @color: #222D91);
              letter-spacing: 1px;
              text-align: center;
              margin-top: 10px; //15px;
              line-height: 18px;
              height: 70px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .data {
              .set-font(@size: 13px, @family: 'os-semibold', @color: #ccc);
              text-align: center;
              margin-top: 0; //27px;
              height: 20px;
            }

            .icona {
              position: absolute;
              right: 5px;
              bottom: 5px;
              color: @oroRiva;
            }
          }
        }

        .dx {
          padding: 0;
          text-align: center;

          a:hover {
            text-decoration: none;
          }

          .titolo {
            padding: 5px 5px;
            display: flex;

            .icona {
              color: #ccc;
              margin-left: 10px;
            }

            .text {
              .set-font(@size: 13px, @family: 'os-semibold', @color: @greenRiva);
              margin-left: 10px;
              letter-spacing: 1px;
              line-height: 16px;
              padding-top: 10px;
              text-align: left
            }
          }

          .nome-doc {
            padding: 0 10px;
            margin-top: 25px;
            text-align: center;
            .set-font(@size: 12px, @family: 'os-semibold', @color: #222D91);
          }

          .icona-pdf {
            color: @oroRiva;
            margin-top: 30px;
          }

          .data {
            position: absolute;
            bottom: 13px;
            width: 100%;
            .set-font(@size: 13px, @family: 'os-semibold', @color: #ccc);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/IndexAccessoStabilimenti.vue